module.exports = __webpack_public_path__ + "static/biocheck-ec42a84d50e579ca3a19023601ec2bbb.jpg";